module.exports = __webpack_public_path__ + "static/media/OutcomeOptionBlue.070963d2.svg";